export const BRAND_BASE = 'base'
export const BRAND_DEBUG = 'debug'
export const BRAND_INSEL = 'insel'
export const BRAND_ROCHE = 'roche'
export const BRAND_SWISSSTEEL = 'swisssteel'

export const PREVIEW_BRANDS = [BRAND_BASE, BRAND_INSEL, BRAND_ROCHE, BRAND_SWISSSTEEL]
export const SUPPORTED_BRANDS = ['', ...PREVIEW_BRANDS.slice(1), BRAND_DEBUG]

export const BRAND_FEATURES = Object.freeze({
  INSEL_ALARM_DEFINITION: 'inselAlarmDefinition',
  INSEL_ALARM_TABLE: 'inselAlarmTable',
  ROCHE_TEMPLATE_LIFESIGN: 'rocheTemplateLifesign',
})

const FEATURES_BY_BRAND = Object.freeze({
  [BRAND_BASE]: [],
  [BRAND_INSEL]: [
    BRAND_FEATURES.INSEL_ALARM_DEFINITION,
    BRAND_FEATURES.INSEL_ALARM_TABLE,
  ],
  [BRAND_ROCHE]: [BRAND_FEATURES.ROCHE_TEMPLATE_LIFESIGN],
  [BRAND_SWISSSTEEL]: [],
})

export function normalizeConfiguredBrand(value) {
  const brand = String(value ?? '').trim().toLowerCase()
  return SUPPORTED_BRANDS.includes(brand) ? brand : ''
}

export function readPreviewBrand(search = '') {
  const value = new URLSearchParams(search).get('brand')
  return PREVIEW_BRANDS.includes(value) ? value : BRAND_BASE
}

export function createBrandContext(configuredBrand = '', search = '') {
  const normalizedBrand = normalizeConfiguredBrand(configuredBrand)
  const debug = normalizedBrand === BRAND_DEBUG
  const activeBrand = debug ? readPreviewBrand(search) : (normalizedBrand || BRAND_BASE)

  return Object.freeze({
    configuredBrand: normalizedBrand,
    activeBrand,
    debug,
    features: Object.freeze([...(FEATURES_BY_BRAND[activeBrand] || [])]),
  })
}

function browserSearch() {
  return typeof window === 'undefined' ? '' : window.location.search
}

export function getBrandContext(search = browserSearch()) {
  return createBrandContext(process.env.VUE_APP_BRAND, search)
}

export function isBrandFeatureEnabled(feature, context = getBrandContext()) {
  return context.features.includes(feature)
}

export function buildBrandPreviewUrl(brand, location = window.location) {
  const selectedBrand = PREVIEW_BRANDS.includes(brand) ? brand : BRAND_BASE
  const params = new URLSearchParams(location.search)
  params.set('brand', selectedBrand)

  const query = params.toString()
  return `${location.pathname}${query ? `?${query}` : ''}${location.hash || ''}`
}
